export default __webpack_public_path__ + "static/media/hilman-img.81581b11.png";